import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN, ESTIMATOR, SELLER } = authRoles

const Invitation = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const invitationModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/invitations',
    name: 'invitations',
    component: Invitation,
    meta: {
      title: 'Invitaciones',
      auth: {
        roles: [ADMIN, ESTIMATOR, SELLER],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
